import { render, staticRenderFns } from "./part-index.vue?vue&type=template&id=5ff59ba7&scoped=true"
import script from "./part-index.vue?vue&type=script&lang=js"
export * from "./part-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff59ba7",
  null
  
)

export default component.exports